import styled from 'styled-components';

const DocumentsStyles = styled.section`
  padding: 4.375rem ${props => props.theme.padding.inner} 5.375rem;
  overflow: hidden;
  background: ${props => props.theme.colors.claytonBlue};
  color: ${props => props.theme.colors.white};
  border-top: 5px solid ${props => props.theme.colors.claytonGreen};
  border-bottom: 5px solid ${props => props.theme.colors.claytonGreen};

  .inner {
    max-width: ${props => props.theme.maxWidths.containerSmall};
    margin: auto;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    @media (min-width: ${props => props.theme.breakpoints.desktop}) {
      max-width: ${props => props.theme.maxWidths.container};
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }
  }

  .content {
    margin-bottom: 3.375rem;

    @media (min-width: ${props => props.theme.breakpoints.desktop}) {
      margin: 0;
      max-width: ${props => props.theme.maxWidths.calculatorContent};
    }

    @media (prefers-reduced-motion: no-preference) {
      .isAnimated& {
        opacity: 0;
        transform: translateY(10px);
      }

      .active& {
        animation: 0.4s ease-in-out slide-in-up forwards;
      }
    }

    h2 {
      margin: 0;
      color: ${props => props.theme.colors.white};
      font-size: ${props => props.theme.type.h1};
    }

    p {
      margin: 0;
      transition-delay: 0.2s;
    }
  }

  .columns {
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    @media (prefers-reduced-motion: no-preference) {
      .isAnimated& {
        opacity: 0;
        transform: translateY(10px);
      }

      .active& {
        animation: 0.4s ease-in-out slide-in-up forwards;
      }
    }

    @media (min-width: ${props => props.theme.breakpoints.desktop}) {
      flex-direction: row;
      align-items: flex-start;
      max-width: 48.375rem;
    }
  }

  .column {
    margin: 1.34375rem 0;

    &:first-child {
      margin-top: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }

    @media (min-width: ${props => props.theme.breakpoints.desktop}) {
      margin: 0 1.4375rem;
      flex-grow: 1;

      &:first-child {
        margin-left: 0;
      }

      &:last-child {
        margin-right: 3rem;
      }
    }

    a {
      color: ${props => props.theme.colors.white};
      font-size: ${props => props.theme.type.button.large};
      margin: 0;
    }

    p {
      margin: 0;
      font-size: ${props => props.theme.type.caption};
    }
  }

  ${props => props.theme.animations.slideInUp};
`;

export default DocumentsStyles;
